import AuthGuard from '@/auth/main/route-guard/AuthGuard';
import Loadable from '@/common/presentation/components/utils/Loader/Loadable';
import { Formik } from 'formik';
import { lazy } from 'react';
import { Outlet } from 'react-router';

type RouteConfig = {
  path: string;
  element: JSX.Element;
  children?: RouteConfig[];
};

const createFeatureRoutes = (
  featureName: string,
  pages: { [key: string]: () => Promise<any> },
  children: { path: string; pageKey: string }[],
): RouteConfig => {
  const resolvedChildren = children.map(({ path, pageKey }) => {
    const pageLoader = pages[pageKey];
    if (!pageLoader) {
      throw new Error(`Page loader for key "${pageKey}" is not defined.`);
    }
    const PageComponent = Loadable(lazy(pageLoader));
    return {
      path,
      element: <PageComponent />,
    };
  });

  return {
    path: featureName,
    element: (
      <AuthGuard>
        <Formik initialValues={{}} onSubmit={() => {}}>
          <Outlet />
        </Formik>
      </AuthGuard>
    ),
    children: resolvedChildren,
  };
};

export default createFeatureRoutes;
